import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, isRef as _isRef, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" OK ")

import { computed, defineAsyncComponent } from 'vue';
import { useLayout } from '@/composables/useLayout';
import { storeToRefs } from 'pinia';
import { useDialogStore } from '@/stores/useDialogStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { layout } = useLayout();
const dialogStore = useDialogStore();
const { active, errorMessage } = storeToRefs(dialogStore);

const layoutComponent = computed(() => layout.value ? defineAsyncComponent(() => import(`@/layouts/${layout.value}.vue`)) : '');

function onCloseModal() {
  dialogStore.closeDialog();
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_loading_dialog = _resolveComponent("loading-dialog")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_modal = _resolveComponent("va-modal")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(layoutComponent)), null, {
    default: _withCtx(() => [
      _createVNode(_component_router_view),
      _createVNode(_component_loading_dialog),
      _createVNode(_component_va_modal, {
        modelValue: _unref(active),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(active) ? (active).value = $event : null)),
        message: _ctx.$t(_unref(errorMessage)),
        "hide-default-actions": "",
        blur: ""
      }, {
        footer: _withCtx(() => [
          _createVNode(_component_va_button, { onClick: onCloseModal }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "message"])
    ]),
    _: 1
  }))
}
}

})